import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { DistributionList3Service } from '../services/distribution3.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { Campaign3TestService } from 'app/views/campaign-3/services/campaign3testservice';
import { DistributionPromo } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-promo-list-detail-3',
  templateUrl: './promo-list-detail-3.component.html',
  styleUrls: ['./promo-list-detail-3.component.css'],
})
export class PromoListDetail3Component implements OnInit {
  @Input() departmentList: Array<any> = [];
  @Output() departmentListSelected: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('promoListDetailKontable') kontableComponent: Campaign3KontableComponent;

  listDepartmentSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  breadcrumbs: Array<BreadCrumbModel> = [];
  actionStatusList: Array<{ label: string; value: string }> = [];
  routeParams: string = '';
  showTable:boolean=false;
  showBreadCrumb:boolean= false;

   
  scopeList: Array<{ label: string; value: string }> = [
 
  ];
  

  constructor(
    private srvNotify: MessageService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public testService: Campaign3TestService,
    public distributionService: DistributionList3Service,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.initBreadCrumbs();
    this.subscribeToRouteParams();
    this.loadFilterList();
  }







  distributionPromoList: DistributionPromo[];
  loadDistributionPromo(id: string) {
    this.distributionService.getDistributionPromoList(id).subscribe(
      res => {
        this.distributionPromoList = res.data;
      },

      error => {
        console.error('Errore durante il caricamento della distribuzione promo:', error);
      }
    );
  }

showErrorMessage(message: string) {
  // Qui puoi implementare la logica per mostrare un messaggio d'errore (es. toast, alert, etc.)
  console.warn(message);
}


  /*
   * Inizializza il breadcrumb per la navigazione.
   */
  private initBreadCrumbs() {
   
    let breadCrumbDistribution;
    let breadCrumbPromo;
    this.translateService.get([
      'breadCrumb.distributionList',
      'breadCrumb.promoDetailList',
     
    ]).subscribe(translations => {
      breadCrumbDistribution = translations['breadCrumb.distributionList'];
      breadCrumbPromo= translations['breadCrumb.promoDetailList']
      this.breadcrumbs = [
        { code: 'bc1', description: breadCrumbDistribution, routerLink: '/distribution-list-3' },
        { code: 'bc2', description: breadCrumbPromo, routerLink: '/promo-list-detail-3' }
      ];
      this.showBreadCrumb= true;
    });
  }
  

  /*
   * Sottoscrive ai parametri della route per ottenere l'ID necessario.
   */
  private subscribeToRouteParams() {
    this.route.queryParams.subscribe(params => {
      this.routeParams = params['idRow'];
      this.loadDistributionPromo(this.routeParams); // La chiamata avviene solo dopo aver ottenuto il parametro
    });
  }

  translationsMap: { [key: string]: string } = {};

  private loadFilterList() {

    this.translateService.get([
      'common.active',
      'common.inactive',
      'campaign.emission',
      'campaign.fruition'
    ]).subscribe(translations => {

      this.translationsMap = translations;
      this.actionStatusList = [
        { label: '', value: '' },
        { label: translations['common.active'], value: '1' },
        { label: translations['common.inactive'], value: '0' }
      ];
      this.scopeList = [
        { label: '', value: '' },
        { label: translations['campaign.emission'], value: 'E' },
        { label: translations['campaign.fruition'], value: 'F' }
      ];
    
      this.showTable= true;

    });
  }
  

  /*
   * Gestisce il click sui breadcrumb per la navigazione.
   */
  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.warn('Nessuna route implementata per questo breadcrumb');
    }
  }
  translateState(value: string): string {
    return this.translationsMap[value === '1' ? 'common.active' : 'common.inactive'] || '';
  }
  translateRulescope(value:string): string{
    return this.translationsMap[value === 'E' ? 'campaign.emission':'campaign.fruition'] || ''
  }


  /*
   * Naviga all'azione specificata, se i parametri sono validi.
   */
  goToTheAction(row: any) {
    const { id: idAction, campaign_id: idCampaign, action_type: actionType } = row;

    if (!idAction || !idCampaign || !actionType) {
      console.error('Parametri mancanti:', { idAction, idCampaign, actionType });
      return;
    }

    let url = `/campaign-3/${idCampaign}/${idAction}`;
    if (actionType === 'MSG') {
      url += '/MSG';
    }

    console.log('Navigazione a:', url);
    this.router.navigate([url]);
  }
}
  


// WEBPACK FOOTER //
// ./src/app/views/distribution-list/promo-list-detail-3/promo-list-detail-3.component.ts